import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';
import { ThemeEvents } from '@theme/events';

class NorthflowQuantityBundles extends Component {
  #controller;
  #variants = [];
  #variantId;

  connectedCallback() {
    super.connectedCallback();
    this.#controller = new AbortController();
    this.#variants = JSON.parse(this.querySelector('[data-bundle-variants]')?.textContent || '[]');
    this.#variantId = this.dataset.variantId;
    const { signal } = this.#controller;
    this.addEventListener('change', this.#onChoice, { signal });
    this.closest('form')?.addEventListener(ThemeEvents.quantitySelectorUpdate, this.#refresh, { signal });
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect, this.#onVariant, { signal });
    this.#refresh();
    this.hidden = false;
  }

  disconnectedCallback() {
    this.#controller?.abort();
    super.disconnectedCallback();
  }

  #onChoice = (event) => {
    if (!(event.target instanceof HTMLInputElement) || event.target.type !== 'radio') return;
    const quantity = this.closest('form')?.querySelector('quantity-selector-component');
    if (!quantity?.setValue) return;
    quantity.setValue(event.target.value);
    quantity.onQuantityChange();
    quantity.updateButtonStates();
    this.#refresh();
  };

  #onVariant = async (event) => {
    try {
      const result = await event.promise;
      if (!this.isConnected || String(result?.detail?.productId || this.dataset.productId) !== this.dataset.productId) return;
      this.#variantId = String(result?.detail?.resource?.id || '');
      this.#refresh();
    } catch {
      this.#refresh();
    }
  };

  #refresh = () => {
    const form = this.closest('form');
    const quantityInput = form?.querySelector('input[name="quantity"]');
    const variant = this.#variants.find(item => String(item.id) === String(this.#variantId));
    if (!variant || !(quantityInput instanceof HTMLInputElement)) return;
    const packMinimum = Number(this.dataset.minPack || 1);
    if (packMinimum > 1) {
      quantityInput.min = String(packMinimum);
      quantityInput.dataset.min = String(packMinimum);
      quantityInput.step = '2';
      if (Number(quantityInput.value) < packMinimum) quantityInput.value = String(packMinimum);
    }
    const quantity = Number(quantityInput.value);
    this.dispatchEvent(new CustomEvent('nf:bundle-change', { bubbles: true, detail: { quantity } }));
    const minimum = Number(quantityInput.min || 1);
    const increment = Number(quantityInput.step || 1);
    const maximum = quantityInput.max ? Number(quantityInput.max) - Number(quantityInput.dataset.cartQuantity || 0) : Infinity;
    for (const label of this.querySelectorAll('.nf-bundles__option')) {
      const radio = label.querySelector('input');
      const count = Number(radio.value);
      const prices = variant.bundles.find(pack => pack.quantity === count) || variant.bundles[count - 1];
      if (!prices) continue;
      const eachLabel = label.querySelector('[data-bundle-each]');
      if (eachLabel) eachLabel.textContent = this.dataset.eachLabel.replace('[amount]', prices.each);
      label.querySelector('[data-bundle-total]').textContent = prices.total;
      const old = label.querySelector('[data-bundle-original]');
      if (old) old.textContent = prices.original;
      const saving = label.querySelector('[data-bundle-saving]');
      if (saving) saving.textContent = prices.saving;
      const unit = label.querySelector('[data-bundle-unit]');
      if (unit && variant.packSize) unit.textContent = this.dataset.packLabel.replace('[packs]', count).replace('[lights]', count * variant.packSize);
      radio.checked = quantity === count;
      if (packMinimum > 1 && radio.checked) {
        for (const price of this.closest('.shopify-section')?.querySelectorAll('[data-nf-pack-price]') || []) {
          price.textContent = prices.total;
        }
        for (const countLabel of this.closest('.shopify-section')?.querySelectorAll('[data-nf-pack-count]') || []) {
          countLabel.textContent = String(count);
        }
      }
      radio.disabled = !variant.available || quantityInput.disabled || count < minimum || count > maximum || (count - minimum) % increment !== 0;
    }
  };
}

if (!customElements.get('nf-quantity-bundles')) customElements.define('nf-quantity-bundles', NorthflowQuantityBundles);

